var heroNav = {
	wrapper: $('.hero-nav-wrapper'),
	triggerButton: $('.hero-nav-list-item a'),
	triggerDropdown: $('.hero-nav-dropdown select'),

	scrollToSection: function(targetId) {
		var targetId_split = targetId.split('#');
		if (targetId_split[0].length > 0) {
			targetId = '#' + targetId_split[1];
		}
		var _targetId = $(targetId);
		var offsetDiff = heroNav.fixOffset(_targetId);

		if (_targetId && _targetId.offset()) {
		    $('html,body').animate({
		        scrollTop: _targetId.offset().top - offsetDiff
		    }, 300, function () {
		        window.location.hash = targetId;
		    });
		}
	},

	fixOffset: function(targetId) {
		var offsetDiff = 20;

		if (windowWidth >= desktop) {
			offsetDiff = 80;
		}
		return offsetDiff;
	},

	eventListeners: function () {
		heroNav.triggerButton.click(function(e){
			e.preventDefault();
			var _this = $(this);
			var targetId = _this.attr('href');
			heroNav.scrollToSection(targetId);
		});

		heroNav.triggerDropdown.change(function(){
			var _this = $(this);
			var targetId = _this.val();
			heroNav.scrollToSection(targetId);
		});
	},

	handeOnLoad: function() {
		var targetSection = window.location.hash;
		heroNav.scrollToSection(targetSection);
	},

	init: function() {
		if (heroNav.wrapper.length) {
			heroNav.eventListeners();
			heroNav.handeOnLoad();
		}
	}
};